module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-layout",
    class: {
      'profile-layout_grid': _vm.showContent
    }
  }, [(_vm.showContent) ? _vm._t("default") : _c('Spinner', {
    attrs: {
      "size": _vm.size
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b92d5f2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/wrapper/swrapper/Swrapper.vue
// module id = 98096afbfd6d055a537f
// module chunks = 89